import type { ObjectMetadata } from '@olytic/foundation';

import { formatMoney, formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asDate, asDateTime, asLabel, createdByField, field, lastModifiedByField, lookup, type Row, show, text } from './kit';

const def = OBJECT_DEFS['billing-schedules'];

/** When a commercial line is billed and how much. Rationale: billing-schedules.md. */
export const billingSchedules: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Billing schedule row',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('label', 'Label'),
    field('planned_date', 'Invoice Date', { format: asDate }),
    field('amount', 'Amount', { format: show(formatMoney) }),
    field('percent', 'Percent', { format: show((v) => `${formatNumber(v)}%`) }),
    field('status', 'Status', { format: asLabel }),
    field('billing_account_name', 'Billing Account', { link: lookup('billing-accounts', 'billing_account_id') }),
    field('source', 'On', { format: asLabel }),
    field('quote_name', 'Quote', { link: lookup('quotes', 'quote_id') }),
    field('order_name', 'Order'),
    field('account_name', 'Account', { link: lookup('accounts', 'account_id') }),
    field('opportunity_name', 'Opportunity', { link: lookup('opportunities', 'opportunity_id') }),
    field('billing_treatment_item_name', 'Treatment Item', { link: lookup('billing-treatment-items', 'billing_treatment_item_id') }),
    field('project_phase_name', 'Project Phase'),
    field('invoice_name', 'Invoice', { link: lookup('invoices', 'invoice_id') }),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['label', 'planned_date', 'amount', 'percent', 'status', 'billing_account_name', 'invoice_name'] },
    {
      key: 'source',
      label: 'Where It Comes From',
      fields: ['source', 'quote_name', 'order_name', 'account_name', 'opportunity_name', 'billing_treatment_item_name', 'project_phase_name'],
    },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'quote_name', 'account_name'],
};
